import { ReactNode } from 'react';
import { IconSearch, IconX } from '@tabler/icons-react';
import { IconButton } from 'src/design-system/IconButton';
import { SearchPill } from 'src/UI/generate-flow/SearchPill';

type CollapsibleSearchProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  children: ReactNode;
};

export function CollapsibleSearch({
  open,
  onOpenChange,
  value,
  onChange,
  placeholder,
  children,
}: CollapsibleSearchProps) {
  const close = () => {
    onChange('');
    onOpenChange(false);
  };

  return (
    <>
      <IconButton
        size={48}
        bg="brand.0"
        c="brand.7"
        style={{ flexShrink: 0 }}
        aria-label={open ? 'Close search' : 'Open search'}
        onClick={() => (open ? close() : onOpenChange(true))}
      >
        {open ? <IconX size={24} /> : <IconSearch size={24} />}
      </IconButton>

      {open ? (
        <SearchPill
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          onEscape={close}
          autoFocus
        />
      ) : (
        children
      )}
    </>
  );
}
